module.exports = __webpack_public_path__ + "img/sankaku_30_blue.b9718fd8.png";